import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { scheduleBid } from '../../../redux/calendar';

import { updateSearchCriteria, searchCustomers } from '../../../redux/searchAppointments';
import AvailableAppointments from './AvailableAppointments';
import { toggleDatasheetsearch } from '../../../redux/searchAppointments';

const colors = createSelector(
  (state) => state.settings.color,
  (state) => state.dropdowns,
  (colorMode, { jobStatuses, jobTypes, offices }) => {
    switch (colorMode) {
      case 'jobStatus':
        return jobStatuses;
      case 'office':
        return offices;
      default:
        return jobTypes;
    }
  }
);

const appointments = createSelector(
  (state) => state.searchAppointments.appointments,
  (state) => state.settings.color,
  colors,
  (appointments, colorMode, colors) => {
    
    return appointments.map((b) => {
      let color = null;
      switch (colorMode) {
        case 'office':
          //const office = b.office;
          const office = colors.find((office) => b.office && office.id === b.office.id);
          color = office ? office.color : null;
          break;
        case 'salesperson':
          const salesperson = b.assignedToResource;
          color = salesperson ? salesperson.calendarColor : null;
          break;
      }
      return { ...b, color };
    });
  }
)

const mapStateToProps = (state) => ({
  ...state.searchAppointments,  
  activeCrew: state.calendar.activeCrew,
  appointments: appointments(state),
  detailEnabled: state.settings.detailEnabled,
  dropdowns: state.dropdowns,
  locationEnabled: state.settings.locationEnabled,
  datasheetsearch:state.searchAppointments.datasheetsearch
});

const mapDispatchToProps = {
  onBidClick: scheduleBid,
  onCustomerSearch: searchCustomers,
  onFormUpdate: updateSearchCriteria,
  onDatasheetSearchChange:toggleDatasheetsearch
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailableAppointments);
